/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindingSeverityEnum } from './FindingSeverityEnum';
import {
    FindingSeverityEnumFromJSON,
    FindingSeverityEnumFromJSONTyped,
    FindingSeverityEnumToJSON,
    FindingSeverityEnumToJSONTyped,
} from './FindingSeverityEnum';
import type { Status111Enum } from './Status111Enum';
import {
    Status111EnumFromJSON,
    Status111EnumFromJSONTyped,
    Status111EnumToJSON,
    Status111EnumToJSONTyped,
} from './Status111Enum';
import type { FindingEvidence } from './FindingEvidence';
import {
    FindingEvidenceFromJSON,
    FindingEvidenceFromJSONTyped,
    FindingEvidenceToJSON,
    FindingEvidenceToJSONTyped,
} from './FindingEvidence';
import type { LogEntry } from './LogEntry';
import {
    LogEntryFromJSON,
    LogEntryFromJSONTyped,
    LogEntryToJSON,
    LogEntryToJSONTyped,
} from './LogEntry';

/**
 * 
 * @export
 * @interface PatchedFinding
 */
export interface PatchedFinding {
    /**
     * 
     * @type {number}
     * @memberof PatchedFinding
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedFinding
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedFinding
     */
    overview?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedFinding
     */
    endpoint?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedFinding
     */
    details?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedFinding
     */
    stepsToReproduce?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedFinding
     */
    impact?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedFinding
     */
    remediationSteps?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedFinding
     */
    additionalNotes?: string | null;
    /**
     * 
     * @type {any}
     * @memberof PatchedFinding
     */
    references?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PatchedFinding
     */
    rawInfo?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PatchedFinding
     */
    classification?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PatchedFinding
     */
    metadata?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PatchedFinding
     */
    authors?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PatchedFinding
     */
    tags?: any | null;
    /**
     * 
     * @type {FindingSeverityEnum}
     * @memberof PatchedFinding
     */
    severity?: FindingSeverityEnum;
    /**
     * 
     * @type {number}
     * @memberof PatchedFinding
     */
    exploitabilityRate?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedFinding
     */
    cve?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedFinding
     */
    cvssScore?: string | null;
    /**
     * 
     * @type {Status111Enum}
     * @memberof PatchedFinding
     */
    status?: Status111Enum;
    /**
     * 
     * @type {number}
     * @memberof PatchedFinding
     */
    assetType?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedFinding
     */
    assetId?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedFinding
     */
    readonly assetTypeName?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedFinding
     */
    readonly assetName?: string;
    /**
     * 
     * @type {Date}
     * @memberof PatchedFinding
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Array<FindingEvidence>}
     * @memberof PatchedFinding
     */
    readonly evidences?: Array<FindingEvidence>;
    /**
     * 
     * @type {Date}
     * @memberof PatchedFinding
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof PatchedFinding
     */
    assignedTo?: number | null;
    /**
     * 
     * @type {Array<LogEntry>}
     * @memberof PatchedFinding
     */
    readonly history?: Array<LogEntry>;
    /**
     * 
     * @type {string}
     * @memberof PatchedFinding
     */
    component?: string | null;
}



/**
 * Check if a given object implements the PatchedFinding interface.
 */
export function instanceOfPatchedFinding(value: object): value is PatchedFinding {
    return true;
}

export function PatchedFindingFromJSON(json: any): PatchedFinding {
    return PatchedFindingFromJSONTyped(json, false);
}

export function PatchedFindingFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedFinding {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'overview': json['overview'] == null ? undefined : json['overview'],
        'endpoint': json['endpoint'] == null ? undefined : json['endpoint'],
        'details': json['details'] == null ? undefined : json['details'],
        'stepsToReproduce': json['steps_to_reproduce'] == null ? undefined : json['steps_to_reproduce'],
        'impact': json['impact'] == null ? undefined : json['impact'],
        'remediationSteps': json['remediation_steps'] == null ? undefined : json['remediation_steps'],
        'additionalNotes': json['additional_notes'] == null ? undefined : json['additional_notes'],
        'references': json['references'] == null ? undefined : json['references'],
        'rawInfo': json['raw_info'] == null ? undefined : json['raw_info'],
        'classification': json['classification'] == null ? undefined : json['classification'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'authors': json['authors'] == null ? undefined : json['authors'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'severity': json['severity'] == null ? undefined : FindingSeverityEnumFromJSON(json['severity']),
        'exploitabilityRate': json['exploitability_rate'] == null ? undefined : json['exploitability_rate'],
        'cve': json['cve'] == null ? undefined : json['cve'],
        'cvssScore': json['cvss_score'] == null ? undefined : json['cvss_score'],
        'status': json['status'] == null ? undefined : Status111EnumFromJSON(json['status']),
        'assetType': json['asset_type'] == null ? undefined : json['asset_type'],
        'assetId': json['asset_id'] == null ? undefined : json['asset_id'],
        'assetTypeName': json['asset_type_name'] == null ? undefined : json['asset_type_name'],
        'assetName': json['asset_name'] == null ? undefined : json['asset_name'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'evidences': json['evidences'] == null ? undefined : ((json['evidences'] as Array<any>).map(FindingEvidenceFromJSON)),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'assignedTo': json['assigned_to'] == null ? undefined : json['assigned_to'],
        'history': json['history'] == null ? undefined : ((json['history'] as Array<any>).map(LogEntryFromJSON)),
        'component': json['component'] == null ? undefined : json['component'],
    };
}

  export function PatchedFindingToJSON(json: any): PatchedFinding {
      return PatchedFindingToJSONTyped(json, false);
  }

  export function PatchedFindingToJSONTyped(value?: Omit<PatchedFinding, 'id'|'asset_type_name'|'asset_name'|'created_at'|'evidences'|'updated_at'|'history'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'overview': value['overview'],
        'endpoint': value['endpoint'],
        'details': value['details'],
        'steps_to_reproduce': value['stepsToReproduce'],
        'impact': value['impact'],
        'remediation_steps': value['remediationSteps'],
        'additional_notes': value['additionalNotes'],
        'references': value['references'],
        'raw_info': value['rawInfo'],
        'classification': value['classification'],
        'metadata': value['metadata'],
        'authors': value['authors'],
        'tags': value['tags'],
        'severity': FindingSeverityEnumToJSON(value['severity']),
        'exploitability_rate': value['exploitabilityRate'],
        'cve': value['cve'],
        'cvss_score': value['cvssScore'],
        'status': Status111EnumToJSON(value['status']),
        'asset_type': value['assetType'],
        'asset_id': value['assetId'],
        'assigned_to': value['assignedTo'],
        'component': value['component'],
    };
}

